export default __webpack_public_path__ + "static/media/payment_remainder_alerticon.27692f1f.svg";